module.exports = __webpack_public_path__ + "static/overtime.c08e132c.svg";